import React from 'react';
import { Col, Row } from 'react-bootstrap';

export default function SummaryHeader({ settlement }) {
  return (
    <>
      <Row className="mt-3">
        <Col xs={12} md={3}>
          <div className="d-flex flex-column mb-3">
            <span className="type">Trabajador:</span>
            <span className="answer">{settlement.employee?.fullName}</span>
          </div>
        </Col>
        <Col xs={12} md={3}>
          <div className="d-flex flex-column mb-3">
            <span className="type">RUT Trabajador:</span>
            <span className="answer">{settlement.employee?.nationalIdentification}</span>
          </div>
        </Col>

        <Col xs={12} md={3}>
          <div className="d-flex flex-column mb-3">
            <span className="type">Tipo de Contrato:</span>
            <span className="answer">{settlement.employee?.contractType}</span>
          </div>
        </Col>

        <Col xs={12} md={3}>
          <div className="d-flex flex-column mb-3">
            <span className="type">Fecha de inicio:</span>
            <span className="answer">{settlement.employee?.startDate}</span>
          </div>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={12} md={3}>
          <div className="d-flex flex-column mb-3">
            <span className="type">Fecha de término:</span>
            <span className="answer">{settlement?.endDate}</span>
          </div>
        </Col>
        <Col xs={12} md={3}>
          <div className="d-flex flex-column mb-3">
            <span className="type">Tiempo trabajado:</span>
            <span className="answer">{settlement.employee?.workedTime}</span>
          </div>
        </Col>
        <Col xs={12} md={3}>
          <div className="d-flex flex-column mb-3">
            <span className="type">Causal de término de contrato:</span>
            <span className="answer">{settlement.terminationReason?.label}</span>
          </div>
        </Col>
      </Row>
    </>
  );
}
